import React, { useContext, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import WishlistAPI from "../../api/promo/wishlistApi";
import { Link } from "react-router-dom";
import { UserContext } from "../../utils/UserContext";

function List() {
  const { user } = useContext(UserContext);
  const [trend, setTrend] = useState(null);
  const [topProducts, setTopProducts] = useState(null);
  const [stats, setStats] = useState(null);

  const fetchDashboard = async () => {
    try {
      const res = await WishlistAPI.dashboard();
      if (res.code === 200) {
        const { trend, topProducts, stats } = res.data;

        setTrend(trend);
        setTopProducts(topProducts);
        setStats(stats);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  if (!trend) return <div>Loading...</div>;

  const trendOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
    },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: trend.map((d) => d.date),
    },
    dataLabels: { enabled: false },
    colors: ["#fe9f43"],
  };

  const trendSeries = [
    {
      name: "Wishlist",
      data: trend.map((d) => d.count),
    },
  ];

  const topOptions = {
    chart: {
      type: "bar",
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        columnWidth: "30%",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        opacityFrom: 1,
        opacityTo: 0.6,
      },
    },
    xaxis: {
      categories: topProducts.map((p) => p.title),
    },
    dataLabels: { enabled: false },
    colors: ["#fe9f43"],
  };

  const topSeries = [
    {
      name: "Wishlist Count",
      data: topProducts.map((p) => p.wishlistCount),
    },
  ];

  const getSecureUrl = (url) => {
    if (!url) return "";
    return `https://${url.replace(/^https?:\/\//, "")}`;
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Wishlist Dashboard</h4>
              <h6>View and organize customer wishlist across your store.</h6>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center overflow-hidden">
                  <span className="avatar avatar-lg bg-primary flex-shrink-0">
                    <i className="ti ti-heart fs-16" />
                  </span>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-medium mb-1 text-truncate">
                      Total Wishlisted Products
                    </p>
                    <h4>{stats?.totalWishlist}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center overflow-hidden">
                  <span className="avatar avatar-lg bg-primary flex-shrink-0">
                    <i className="ti ti-users fs-16" />
                  </span>
                  <div className="ms-2 overflow-hidden">
                    <p className="fs-12 fw-medium mb-1 text-truncate">
                      Total Users
                    </p>
                    <h4>{stats?.totalUsers}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xxl-7 col-xl-7 col-sm-12 col-12">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-primary fs-16 me-2">
                    <i className="ti ti-shopping-cart" />
                  </span>
                  <h5 className="card-title mb-0">Top Wishlisted Products</h5>
                </div>
              </div>
              <div className="card-body pb-0">
                <Chart options={topOptions} series={topSeries} type="bar" />
              </div>
            </div>
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-primary fs-16 me-2">
                    <i className="ti ti-shopping-cart" />
                  </span>
                  <h5 className="card-title mb-0">Wishlist Trend</h5>
                </div>
              </div>
              <div className="card-body pb-0">
                <Chart
                  options={trendOptions}
                  series={trendSeries}
                  type="line"
                />
              </div>
            </div>
          </div>

          <div className="col-xxl-5 col-xl-5 col-sm-12 col-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">Top Products</h5>
              </div>
              <div className="card-body">
                {topProducts &&
                  topProducts.length > 0 &&
                  topProducts.map((item, index) => (
                    <div className="d-flex align-items-center justify-content-between mb-4" key={index}>
                      <div className="d-flex align-items-center">
                        {item.thumbnail && (
                          <a
                            href={`${getSecureUrl(user.websiteUrl)}/shop/${item.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="avatar avatar-lg"
                          >
                            <img src={item.thumbnail} alt="img" />
                          </a>
                        )}

                        <div className="ms-2">
                          <h6 className="fw-bold mb-1">
                            <a
                              href={`${getSecureUrl(user.websiteUrl)}/shop/${item.slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.title}
                            </a>
                          </h6>
                          <div className="d-flex align-items-center item-list">
                            <p>
                              Wishlisted by <b>{item.wishlistCount}</b>{" "}
                              users{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="text-end">
                        <Link
                          to={`/wishlist/user/${item.productId}`}
                          className="btn btn-primary btn-xs"
                        >
                          View
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default List;
